import React from "react";
import { BsFileText } from "react-icons/bs";
import { CiBarcode } from "react-icons/ci";
import styled from "styled-components";
import { formatCurrency } from "utils";
import PixGray from "assets/images/icons/pix-gray.svg"

const CardDebitInfo = ({
  name,
  amount,
  isBill = false,
  isPix = false
}: {
  name: string;
  amount: number;
  isBill?: boolean;
  isPix?: boolean;
}) => {
  return (
    <DebtCard>
      <DebtIconWrapper>
        {isBill && <CiBarcode size={24} color="#999" />}
        {(!isPix && !isBill) && <BsFileText height={20} color="#999" />}
        {isPix && <img src={PixGray} height={20} />}
      </DebtIconWrapper>
      <DebtInfo>
        <DebtDescription>{name}</DebtDescription>
        <DebtAmount>{formatCurrency(amount)}</DebtAmount>
      </DebtInfo>
    </DebtCard>
  );
};

const Card = styled.div`
  background: white;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  align-items: center;
  margin-bottom: 12px;
`;

const DebtCard = styled(Card)`
  gap: 16px;
`;

const DebtIconWrapper = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const DebtInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 6px;
  align-items: start;
`;

const DebtDescription = styled.div`
  font-size: 14px;
  color: #333;
`;

const DebtAmount = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #333;
`;

export default CardDebitInfo;
